import { render, staticRenderFns } from "./CreateBoccoChannelForm.vue?vue&type=template&id=cea03fda&scoped=true&"
import script from "./CreateBoccoChannelForm.vue?vue&type=script&lang=ts&"
export * from "./CreateBoccoChannelForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBoccoChannelForm.vue?vue&type=style&index=0&id=cea03fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea03fda",
  null
  
)

export default component.exports